import { createAction } from '@reduxjs/toolkit'
import { FarmStatus, SortBy } from '../../components/farms'

export const updateSearchQuery = createAction<string>('farms/updateSearchQuery')

export const updateFarmStatusOption = createAction<FarmStatus>('farms/updateFarmStatusOption')

export const updateSortByOption = createAction<SortBy>('farms/updateSortByOption')
